import{
    SET_CURRENT_QUES_ID,
    SET_LEADERBOARD_LIST,
    SET_EDIT_LEADER_BOARD_LIST, 
    SET_LEADERBOARD_EVENTS,
    SET_LEADERBOARD_QUESTIONS,
    SET_EDIT_LEADER_BOARD_QUESTION_DATA,
    SET_DROPDOWN_QUESTIONS_LIST,
    SET_IS_GET_EVENTS_LEADERBOARD_LISTS_PENDING,
    SET_IS_GET_DROPDOWN_QUESTIONS_LIST_PENDING,
    SET_IS_GET_QUESTIONS_LEADERBOARD_LISTS_PENDING,
    SET_CONTINOUS_EVALUATE_PENDING,
    SET_IS_EDIT_LEADERBOARD_PENDING,
    SET_LOCK_EDITING_PENDING,
    SET_CURRENT_QUESTION_ID,
    SET_UNLOCK_EDITING_PENDING
} from "../constants/leaderboard.constants";

const initialState: eventsState = {
    currentQuesID: null,
    leaderboardList: null,
    editLeaderboardList: null,
    editLeaderboardEventsList: null,
    editLeaderboardQuestionsList: null,
    editLeaderboardQuestionData: null,
    dropdownQuestionsList: null,
    isGetEventsleaderboardListsPending: false,
    isGetQuestionsleaderboardListsPending: false,
    isGetDropdownQuestionsListPending: false,
    isContinousEvaluatePending: false,
    isEditLeaderboardPending: false,
    isLockEditingPending: false,
    isEditingLocked: false,
    currentQuestionId: null,
    isUnlockEditingPending: false,
    allowRepeatedCalls: false,
    lockedUserId: null
};

export default (
    localState: eventsState = initialState,
    action: Action
): eventsState => {
    switch(action.type)
    {

        case SET_CURRENT_QUES_ID: {
            return {
                ...localState,
                currentQuesID: action.payload
            }
        }

        case SET_LEADERBOARD_LIST: {
            const { leaderboardList } = action.payload
            return{
                ...localState,
                leaderboardList: leaderboardList
            }
        }

        case SET_EDIT_LEADER_BOARD_LIST: {
            return{
                ...localState,
                editLeaderboardList: action.payload
            }
        }
        case SET_LEADERBOARD_EVENTS:{
            return{
                ...localState,
                editLeaderboardEventsList: action.payload
    
            }
        }

        case SET_LEADERBOARD_QUESTIONS:{
            return{
                ...localState,
                editLeaderboardQuestionsList: action.payload
    
            }
        }

        case SET_EDIT_LEADER_BOARD_QUESTION_DATA:{
            return{
                ...localState,
                editLeaderboardQuestionData: action.payload,
            }
        }

        case SET_DROPDOWN_QUESTIONS_LIST:{
            return{
                ...localState,
                dropdownQuestionsList: action.payload,
            }
        }

        case SET_IS_GET_EVENTS_LEADERBOARD_LISTS_PENDING:{
            return{
                ...localState,
                isGetEventsleaderboardListsPending: action.payload,
            }
        }

        case SET_IS_GET_DROPDOWN_QUESTIONS_LIST_PENDING:{
            return{
                ...localState,
                isGetDropdownQuestionsListPending: action.payload,
            }
        }

        case SET_IS_GET_QUESTIONS_LEADERBOARD_LISTS_PENDING:{
            return{
                ...localState,
                isGetQuestionsleaderboardListsPending: action.payload,
            }
        }

        case SET_CONTINOUS_EVALUATE_PENDING:{
            return{
                ...localState,
                isContinousEvaluatePending: action.payload,
            }
        }

        case SET_IS_EDIT_LEADERBOARD_PENDING:{
            return{
                ...localState,
                isEditLeaderboardPending: action.payload,
            }
        }
        case SET_LOCK_EDITING_PENDING: {
            return {
                ...localState,
                isLockEditingPending: action.payload
            }
        }
        case SET_CURRENT_QUESTION_ID: {
            return {
                ...localState,
                currentQuestionId: action.payload,
                allowRepeatedCalls: true
            }
        }
        case SET_UNLOCK_EDITING_PENDING: {
            return {
                ...localState,
                isUnlockEditingPending: action.payload
            }
        }
        default: {
            return localState;
        }
    }
}